import { render, staticRenderFns } from "./creatPaper.vue?vue&type=template&id=2d913f2b"
import script from "./creatPaper.vue?vue&type=script&lang=js"
export * from "./creatPaper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports